/* CCS 2026 Design: site-wide motion (Tier 1). Vanilla JS, transform and opacity only, nothing moves under prefers-reduced-motion.
   - Reveal: content that starts below the first screen fades up 16px once (IntersectionObserver), grids stagger 60 ms, max 6 per batch.
   - Parallax: hero and making photos drift a few px with scroll; starts only after the first scroll, so the hero (LCP) is never animated during load.
   - Gift Finder: result cards fade up on each change. Free delivery bar: .ccs-freebar__fill scales with --ccs-p (CSS).
   First-screen content is never hidden; the homepage ccs sections keep their own reveal in ccs-home.js, and anything Dawn already animates (.scroll-trigger) is skipped. */
(function(){
'use strict';
if(window.ccsMotion)return;window.ccsMotion=1;
var D=document,R=D.documentElement;
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
if(RM||!('IntersectionObserver' in window))return;
R.classList.add('ccs-mo');
function qsa(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s));}
/* footer is never hidden (it can sit in the first screen on short pages and shifted on reveal; fix 13 Oct 15:56) */
var SEL=['main .product-grid > li','main .collection-hero__text-wrapper','main .ccs-pdp__desc','main .ccs-pdp__panel','main .ccs-pdp--more > *','main .jdgm-rev-widg','main .related-products .product-grid > li','main .rte > *','main .title-wrapper-with-link','main .cart__footer','main .main-page-title','main .page-width > .rte','main .article-card-wrapper','main .multicolumn-list__item','main .image-with-text__media','main .image-with-text__text-item','main .collapsible-content__grid > *','main .accordion','main .contact__fields','main .contact__button','main .rich-text__blocks > *','main .template-404 > *','main .blog-articles__article','main .article-template__content','main .newsletter__wrapper','main .ccs-about__step','main .ccs-about__close .ccs-wrap > *','main .ccs-pg__line','main .ccs-pg__form','main .ccs-pg__group','main .ccs-pg__qa','main .ccs-pg__close .ccs-wrap > *'];
var batch=[],raf=0;
var io=new IntersectionObserver(function(es){
 es.forEach(function(e){if(e.isIntersecting){batch.push(e.target);io.unobserve(e.target);}});
 if(!raf)raf=requestAnimationFrame(function(){raf=0;batch.forEach(function(el,i){el.style.transitionDelay=(Math.min(i,5)*60)+'ms';el.classList.add('is-in');if(el.classList.contains('ccs-words'))wordsDone(el);});batch=[];});
},{threshold:.08,rootMargin:'0px 0px -5% 0px'});
/* Word motion v1: headings marked data-ccs-words rise word by word, once. Same io observer, same once rule.
   Split only below the first screen, max 6 words, never while the page is machine-translated.
   Accessible: full text stays in a .visually-hidden copy; the moving copy is aria-hidden. The split is removed when the motion ends. */
var WMAX=6,WDUR=700,WLEAD=80,WSTEP=60;
function translated(){return /\btranslated-(ltr|rtl)\b/.test(R.className);}
function wrapWords(node,ctr){
 Array.prototype.slice.call(node.childNodes).forEach(function(n){
  if(n.nodeType===1){wrapWords(n,ctr);return;}
  if(n.nodeType!==3||!n.nodeValue)return;
  var f=D.createDocumentFragment();
  n.nodeValue.split(/(\s+)/).forEach(function(t){
   if(!t)return;
   if(/^\s+$/.test(t)){f.appendChild(D.createTextNode(t));return;}
   var s=D.createElement('span');s.className='ccs-w';s.style.setProperty('--ccs-wi',Math.min(ctr.i,WMAX-1));ctr.i++;
   s.textContent=t;f.appendChild(s);
  });
  node.replaceChild(f,n);
 });
}
function unsplit(h){
 var o=h.querySelector(':scope > .ccs-words__a11y'),v=h.querySelector(':scope > .ccs-words__vis');
 if(!o||!v)return;
 h.removeChild(v);while(o.firstChild)h.insertBefore(o.firstChild,o);h.removeChild(o);
 h.dataset.ccsWords='done';
}
function split(h){
 if(h.dataset.ccsWords==='done'||translated())return false;
 var n=h.textContent.trim().split(/\s+/).length;
 if(!n||n>WMAX)return false;
 var before=h.getBoundingClientRect();
 var o=D.createElement('span');o.className='visually-hidden ccs-words__a11y';
 var v=D.createElement('span');v.className='ccs-words__vis';v.setAttribute('aria-hidden','true');
 var c=h.cloneNode(true);c.removeAttribute('id');
 while(h.firstChild)o.appendChild(h.firstChild);
 var ctr={i:0};wrapWords(c,ctr);while(c.firstChild)v.appendChild(c.firstChild);
 h.classList.add('ccs-words');/* class first, so the words are styled hidden from their first frame */
 h.appendChild(o);h.appendChild(v);
 var after=h.getBoundingClientRect();
 if(Math.abs(after.height-before.height)>.5||Math.abs(after.width-before.width)>.5){unsplit(h);h.classList.remove('ccs-words');h.dataset.ccsWords='';return false;}
 h.dataset.ccsWords='split';h.dataset.ccsWn=ctr.i;
 return true;
}
function wordsDone(h){/* called when io adds is-in: drop the split once the last word has landed */
 var n=+h.dataset.ccsWn||1;
 setTimeout(function(){unsplit(h);},WLEAD+(Math.min(n,WMAX)-1)*WSTEP+WDUR+50);
}
function tagWords(root){
 if(window.Shopify&&Shopify.designMode)return;/* theme editor: headings stay static */
 var vh=innerHeight;
 qsa('[data-ccs-words]',root).forEach(function(h){
  if(h.classList.contains('ccs-mrv')||h.closest('.scroll-trigger')||h.closest('.ccs-mrv, .ccs-rv'))return;/* never double-animate */
  if(h.getBoundingClientRect().top<vh)return;/* first screen: never hidden */
  split(h);/* adds .ccs-words when split; if not split, the whole heading fades like the Tier 1 reveal */
  h.classList.add('ccs-mrv');io.observe(h);
 });
}
/* if the visitor turns on page translation mid-way, show everything now and drop the split */
if('MutationObserver' in window)new MutationObserver(function(){if(!translated())return;
 qsa('.ccs-words').forEach(function(h){h.classList.add('is-in');unsplit(h);});}).observe(R,{attributes:true,attributeFilter:['class']});


function tag(root){
 var vh=innerHeight;
 qsa(SEL.join(','),root).forEach(function(el){
  if(el.querySelector('[data-ccs-words]')||(el.closest('.ccs')&&!el.closest('.ccs-about,.ccs-pg'))||el.closest('details:not([open])')||el.classList.contains('scroll-trigger')||el.closest('.scroll-trigger')||el.querySelector('.scroll-trigger')||el.classList.contains('ccs-mrv')||el.querySelector('h1')||el.matches('h1'))return;
  if(el.getBoundingClientRect().top<vh)return;
  el.classList.add('ccs-mrv');io.observe(el);
 });
}
/* parallax: transform only, after first scroll, one rAF per frame */
var px=[],on=false,tick=false;
function collect(){px=qsa('.ccs-hero__media img, .ccs-final__media img, .ccs-pdp-parallax img');}
function upd(){tick=false;if(R.classList.contains('ccs-story-pinned'))return;var vh=innerHeight;px.forEach(function(img){var r=img.parentNode.getBoundingClientRect();if(r.bottom<0||r.top>vh)return;var p=(r.top+r.height/2-vh/2)/vh;img.style.transform='translate3d(0,'+(p*-18).toFixed(1)+'px,0) scale(1.06)';});}
function onScroll(){if(!on){on=true;R.classList.add('ccs-px-on');}if(!tick){tick=true;requestAnimationFrame(upd);}}
/* gift finder: fade results in on change */
function finderFx(){
 qsa('[data-ccs-finder]').forEach(function(f){
  f.addEventListener('click',function(e){
   if(!(e.target.closest&&e.target.closest('.ccs-chip')))return;
   requestAnimationFrame(function(){qsa('[data-ccs-cards] .ccs-card:not([hidden])',f).forEach(function(c,i){c.classList.remove('ccs-fin');void c.offsetWidth;c.style.animationDelay=(i*60)+'ms';c.classList.add('ccs-fin');});});
  });
 });
}
function init(){tagWords();tag();collect();if(px.length)addEventListener('scroll',onScroll,{passive:true});finderFx();}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',init);else init();
D.addEventListener('shopify:section:load',function(e){tagWords(e.target);tag(e.target);collect();});
})();
